import React, { Component } from 'react';
import cn from "classnames";
import styles from "./RoomQueue.scss";
import { connect } from "react-redux";
import services from "../../services/services";
import { parseRoomURL } from "../../utils/utilsChat";

const mapStateToProps = state => ({
  currentRoomQueue: state.currentRoomQueue,
});

@connect(mapStateToProps)
export class RoomQueue extends Component {
  state = {
    queueList: [],
    companyId: null,
  };

  componentDidMount() {
    const { companyId } = parseRoomURL(window.location.pathname);
    this.setState({ companyId }, () => {
      this.fetchRoomQueue();
      this.intervalId = setInterval(this.fetchRoomQueue, 5000);
    });
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  fetchRoomQueue = async () => {
    const { companyId } = this.state;
    if (!companyId) {
      return;
    }

    try {
      const queue = await services.roomListSubscription.getRoomQueue(companyId);

      const queueList = [
        {
          id: 'inProgressRooms',
          title: 'Обращения в работе',
          value: queue.inProgressRooms,
        },
        {
          id: 'inQueue',
          title: 'В очереди',
          value: queue.reservedRooms + queue.waitAssignRooms,
        },
        {
          id: 'total',
          title: 'Всего',
          value: queue.inProgressRooms + queue.waitAssignRooms + queue.reservedRooms,
        },
      ];

      this.setState({ queueList });
    } catch (error) {
      console.error("Ошибка при загрузке очереди:", error);
    }
  };

  render() {
    const { queueList } = this.state;
    const { className } = this.props;

    return (
      <ul className={cn(className, styles.container)}>
        {queueList.map(queue => (
          <li key={queue.id}>
            {queue.title}: {queue.value}
          </li>
        ))}
      </ul>
    );
  }
}
